import { Helmet } from 'react-helmet';

function BlogHeader() {
  return (
        <section className="blog-page">
            <Helmet>
                <title>Блог на Векота</title>
                {/* <meta property="og:description" content="Изработка на софтуер, сайтове, онлайн магазини, мобилни приложения" /> */}
            </Helmet>
            <div className="container">
                <div className="row">
                    <div className="col-12 ">
                        <div className="swiper-container blog-page-slider">
                            <div className="">
                                <div className="swiper-slide slide-content d-flex align-items-center">
                                    <div className="single-slide">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BlogHeader;
